import { render, staticRenderFns } from "./PerformanceTarget.vue?vue&type=template&id=8385af64&scoped=true&"
import script from "./PerformanceTarget.vue?vue&type=script&lang=js&"
export * from "./PerformanceTarget.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceTarget.vue?vue&type=style&index=0&id=8385af64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8385af64",
  null
  
)

export default component.exports